import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, DataListItem } from '@node-space/ui-components'
import { BatchStatus } from '../types'

export type MassPayoutListSidePanelBodyProps = {
  dateCreated: string
  uploadedBy: string
  paidFromWallet: string
  batchReference?: string
  batchStatus?: string
  onViewBatchTransaction?: () => void
}

export const MassPayoutListSidePanelBody = ({
  dateCreated,
  uploadedBy,
  paidFromWallet,
  batchReference,
  batchStatus,
  onViewBatchTransaction,
}: MassPayoutListSidePanelBodyProps) => {
  const { t } = useTranslation()

  const shouldShowButton =
    batchReference && onViewBatchTransaction && batchStatus !== BatchStatus.COMPLETED

  return (
    <Box>
      <h4 className="text-foreground-prominent text-h4">{t('transactionDetails')}</h4>

      <Box paddingT={8} paddingB={4}>
        {dateCreated && (
          <DataListItem
            id="date-created"
            testId="date-created"
            title={t('massPayouts.dateCreated')}
            body={dateCreated}
          />
        )}
      </Box>
      <Box paddingT={4} paddingB={4}>
        {uploadedBy && (
          <DataListItem
            id="uploaded-by"
            testId="uploaded-by"
            title={t('massPayouts.uploadedBy')}
            body={uploadedBy}
          />
        )}
      </Box>
      <Box paddingT={4} paddingB={12}>
        {paidFromWallet && (
          <DataListItem
            id="paid-from-wallet"
            testId="paid-from-wallet"
            title={t('massPayouts.paidFromWallet')}
            body={paidFromWallet}
          />
        )}
      </Box>

      {shouldShowButton && (
        <Box paddingT={4} paddingB={12}>
          <Button
            className="w-full"
            testId="view-batch-transaction"
            onClick={onViewBatchTransaction}
          >
            {t('massPayouts.viewBatchTransactions')}
          </Button>
        </Box>
      )}
    </Box>
  )
}
